module.exports = __webpack_public_path__ + "static/media/logoFundo.cae837ed.png";